import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-library',
  templateUrl: './about-library.component.html',
  styleUrls: ['./about-library.component.scss']
})
export class AboutLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
